let $ = jQuery.noConflict(),
	devMode,
	body,
	mobileCheck = false,
	currentY,
	scrollBar,
	noTouchEvent,
	pageTransition,
	resizeCallbacks = [];

$(function () {
	initStarterKit();

	// Composants Mobile & Desktop
	new BigBackgroundText();
	new BigScrollText();
	new BigTiles();
	new Booking();
	new FullScreenGallery();
	new Header();
	new IntroSection();
	new Payment();

	if (mobileCheck.isMobile) {

	}else{
		new SectionBackgroundScroll();
	}
});

function initStarterKit() {
	body = $('body');
	devMode = localStorage.getItem('devMode');
	mobileCheck = new MobileCheck();
	debugBootstrap();
	noTouchEvent = $('html').hasClass('no-touchevents');
	new SmoothScroll();
	pageTransition = new CustomPageTransition();
	new BasePageTransition();
	new AppearOnScroll();
	new DataLink();
	new DraggableEvents();
	new Forms();
	new MadeByMcube();
}

function scrollListener(newY) {

}
